import { render, staticRenderFns } from "./AccountCard.vue?vue&type=template&id=0e74778e"
import script from "./AccountCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AccountCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports